export const productCategory = {
    namespaced: true,
    state: {
        data: {
            availability: {
                id: null,
                base_cost: null
            },
            category: {
                id: null
            }

        }
    },

    getters: {
        getProductCategory(state) {
            return state.data.category
        },
        getProductAvailability(state) {
            return state.data.availability
        }
    },

    mutations: {
        SET_PRODUCT_AVAILABILITY(state, payload) {
            state.data.availability = { ...payload }
        },
        SET_PRODUCT_CATEGORY(state, payload){
            state.data.category = { ...payload }
        },
        SAVED_PRODUCT_CATEGORY() {
        },
        UPDATE_PRODUCT_CATEGORY() {
        },
        DELETE_PRODUCT_CATEGORY() {
        }
    },

    actions: {
        setProductCategory({ commit }, payload) {
            commit('SET_PRODUCT_CATEGORY', payload)
        },
        setProductAvailability({ commit }, payload) {
            commit('SET_PRODUCT_AVAILABILITY', payload)
        },
        savedProductCategory({ commit }, payload , type) {
            commit('SAVED_PRODUCT_CATEGORY', payload , type)
        },
        updateProductCategory({ commit }, payload) {
            commit('UPDATE_PRODUCT_CATEGORY', payload)
        },
        deleteProductCategory({ commit }, payload) {
            commit('DELETE_PRODUCT_CATEGORY', payload )
        }
    }
}